import { CrudDecorator, CrudDecoratorBehavior, DataHeader } from "@mcleod/components";

export class AppCrudDecoratorBehavior extends CrudDecoratorBehavior {
    constructor() {
        super();
    }

    public insertDataHeader(decorator: CrudDecorator, dataHeader: DataHeader): void {
        decorator.layout.insert(dataHeader, 0);
    }
}

AppCrudDecoratorBehavior.register();
